import { Grid } from '@mui/material';
import { CSSProperties, ReactNode } from 'react';

interface FlexibleColumnsProps {
  children: ReactNode[];
  containerStyle?: CSSProperties;
  columnWidths: number[];  // Array of numbers specifying the widths of the columns
  gap?: number;
}

const FlexibleColumns = ({ children, containerStyle, columnWidths }: FlexibleColumnsProps) => {
  const totalWeight = columnWidths.reduce((total, num) => total + num, 0);

  return (
    <Grid container style={{ height: '100%', ...containerStyle }}   >
      {children.map((_, index) => (
        <Grid
          key={index}
          container
          item
          md={columnWidths[index]}
          style  = {{height:'fit-content'}}
        >
          {children[index]}
        </Grid>
      ))}
    </Grid>
  );
};

export default FlexibleColumns;
